const routesPaths = {
  map: '/',
};

export default routesPaths;
